// ---------------------------------------------------------------------------
// Central, typed content layer for the Siaq platform.
// All services, projects, knowledge and products come from here — never JSX.
// Replaceable later by a CMS. Every record with legacy origin carries
// sourceUrl / contentStatus / lastReviewedAt.
// ---------------------------------------------------------------------------

export const ASSETS = {
  logo: "/assets/logo-siaq.png",
  logoMark: "/assets/logo-mark.png",
  heroLobby: "/assets/hero-siaq-lobby.webp",
  heroClockTower: "/assets/hero-siaq.jpg",
  meeting: "/assets/img_045710.jpeg",
  staircase: "/assets/img_045700.jpeg",
  pattern: "/assets/img_045645.jpeg",
};

export const BRAND = {
  name: "سياق",
  latin: "Siaq",
  tagline: "للاستشارات وحلول تمكين القدرات",
  promise: "لسياقك نبتكر",
  email: "info@siaq-sa.com",
  socials: [
    { label: "لينكدإن", name: "LinkedIn", href: "https://www.linkedin.com/company/%D8%B3%D9%8A%D8%A7%D9%82-%D9%84%D9%84%D8%A7%D8%B3%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%88%D8%AD%D9%84%D9%88%D9%84-%D8%AA%D9%85%D9%83%D9%8A%D9%86-%D8%A7%D9%84%D9%82%D8%AF%D8%B1%D8%A7%D8%AA" },
    { label: "إنستغرام", name: "Instagram", href: "https://instagram.com/siaqsa1" },
    { label: "منصة إكس", name: "Twitter", href: "https://twitter.com/siaqsa1" },
    { label: "يوتيوب", name: "YouTube", href: "https://www.youtube.com/channel/UCpULJCYGioBo-McdQBdyN8g/videos" },
  ],
};

export const NAV = [
  { label: "عن سياق", href: "/about" },
  { label: "مساراتنا في التأثير", href: "/services" },
  { label: "أثرنا", href: "/impact" },
  { label: "انضم لفريق سياق", href: "/careers" },
  { label: "إصداراتنا المعرفية", href: "/publications" },
  { label: "أخبارنا", href: "/news" },
];

export const FOOTER_LINKS = {
  siaq: [
    { label: "الرئيسية", href: "/" },
    { label: "عن سياق", href: "/about" },
    { label: "مساراتنا في التأثير", href: "/services" },
    { label: "أثرنا", href: "/impact" },
    { label: "انضم لفريق سياق", href: "/careers" },
  { label: "إصداراتنا المعرفية", href: "/publications" },
  { label: "أخبارنا", href: "/news" },
  ],
  more: [
    { label: "الملف التعريفي", href: "/profile" },
    { label: "الانضمام إلينا", href: "/contact" },
    { label: "سياسة الخصوصية", href: "/privacy" },
    { label: "الشروط والأحكام", href: "/terms" },
  ],
};

// ---------------------------------------------------------------------------
// Impact paths (the 7 real paths). Single source: text + cta come from here.
// ---------------------------------------------------------------------------
const RAW_PATHS = [
  {
    id: 1,
    slug: "community-participation",
    title: "المشاركة المجتمعية",
    description:
      "نعمل على تمكين منظومة العمل المجتمعي وتحويلها إلى منظومة مستدامة ذات أثر ملموس، عبر تصميم تدخلات نوعية ومبتكرة تسهم في تعزيز وبناء مجتمع حيوي متطوع ومبادر.",
  },
  {
    id: 2,
    slug: "social-innovation",
    title: "الابتكار الاجتماعي",
    description:
      "نصمم حلولًا مبتكرة للتحديات الملحة والمعقدة، من خلال دمج منهجيات الابتكار مع الأدوات التقنية الحديثة، لنصنع نماذج عمل مبتكرة قابلة للتطبيق والقياس.",
  },
  {
    id: 3,
    slug: "social-investment",
    title: "الاستثمار الاجتماعي",
    description:
      "نركز على توجيه رأس المال نحو تدخلات تدمج بين العائد المالي والأثر الاجتماعي المستدام، لنمكن المستثمرين من تحقيق معادلة «الربح الهادف» وبناء محافظ تسهم في التنمية الاقتصادية والاجتماعية.",
  },
  {
    id: 4,
    slug: "guests-of-rahman",
    title: "منظومة ضيوف الرحمن",
    description:
      "نكرس خبراتنا للارتقاء بمنظومة ضيوف الرحمن عبر تطوير حلول وخدمات نوعية تثري تجربة مستفيدي المنظومة، مستندين إلى فهمنا ووعينا العميق بهذه المنظومة.",
  },
  {
    id: 5,
    slug: "social-entrepreneurship",
    title: "الريادة الاجتماعية",
    description:
      "نمكن رواد الأعمال الاجتماعيين عبر تزويدهم بالأدوات والمعرفة والشبكات اللازمة لتحويل شغفهم بالتغيير إلى مبادرات ريادية ناجحة ومستقلة ماليًا وقادرة على خلق قيمة مجتمعية.",
  },
  {
    id: 6,
    slug: "community-development",
    title: "تنمية المجتمعات",
    description:
      "نتبنى نهجًا شموليًا في تمكين المجتمعات المحلية، من خلال دراسة احتياجاتها وتصميم برامج تنموية تعزز قدرات أفرادها وتستثمر في مواردها الذاتية.",
  },
  {
    id: 7,
    slug: "social-responsibility",
    title: "المسؤولية الاجتماعية",
    description:
      "نساعد القطاع الخاص على بناء توجهات واستراتيجيات للمسؤولية الاجتماعية تتجاوز العمل التقليدي، لتصبح جزءًا متجذرًا من هوية المنظمة وعملياتها وثقافتها المؤسسية.",
  },
];

// Every impact-path state is a SINGLE record: text + image + cta + lens come from here.
const PATH_LENS = {
  "community-participation": "18% 32%",
  "social-innovation": "34% 24%",
  "social-investment": "50% 40%",
  "guests-of-rahman": "66% 26%",
  "social-entrepreneurship": "40% 60%",
  "community-development": "24% 58%",
  "social-responsibility": "70% 55%",
};

export const PATHS = RAW_PATHS.map((p) => ({
  ...p,
  imageId: "meeting",
  imageAlt: "مشهد تعبيري لعمل تعاوني داخل مكتب زجاجي",
  ctaLabel: "ابدأ تشخيص هذا المسار",
  ctaHref: `/discover-context?service=${p.slug}`,
  lensPosition: PATH_LENS[p.slug],
}));

export const APPROACH = {
  heading: "نبدأ أولًا بفهم السياق",
  nodes: [
    { k: "٠١", title: "نستوعب الاحتياج", text: "نُنصت للمنظمة ونقرأ واقعها كما هو، قبل أي افتراض" },
    { k: "٠٢", title: "نحلّل السياق", text: "نحلّل المعطيات والسياقات ذات العلاقة والعوامل المحيطة لنرى الصورة الشاملة" },
    { k: "٠٣", title: "نبتكر الحل", text: "نصمّم ونبتكر تدخلًا مفصلًا يلائم المنظمة ويقودها نحو أثر مستدام" },
  ],
};

// ---------------------------------------------------------------------------
// About / manifesto
// ---------------------------------------------------------------------------
export const MANIFESTO = {
  chapters: [
    {
      n: "٠١",
      title: "السياق هو الأسلوب أو الإطار",
      short: "أسلوب الفهم الدقيق للاحتياج وتحليل كافة الزوايا؛ لنصمّم الحل المبتكر الملائم للسياق والإطار.",
      body:
        "يرتبط هذا المدلول بشكل وثيق مع الخدمات الاستشارية التي نقدمها في سياق؛ حيث نعتمد أسلوب الفهم الدقيق للاحتياج، وإجراء عمليات التحليل المتعمّقة لكافة الزوايا والسياقات ذات العلاقة بالخدمة الاستشارية المراد تقديمها، والاطلاع على أفضل التجارب والممارسات العالمية، ثم الشروع بتصميم الحلول المبتكرة والمناسبة للسياق والإطار الملائم للجهة المستهدفة، والذي يلبّي بطبيعة الحال التوقعات والتطلعات وفق إطار مهني معتبر تتحقّق عبره التوجّهات المأمولة.",
    },
    {
      n: "٠٢",
      title: "لسياقك نبتكر",
      short: "ندرك أن لكل منظمة حالة خاصة من التفرد، ولذلك نبتكر حلولًا فعالة ومتناسقة مع سياقها.",
      body:
        "ندرك في سياق بأن كل منظمة لها حالة خاصة من التفرد، مما يؤكد لنا التوجه الدائم نحو ابتكار الحلول الفعالة والمتناسقة لسياق المنظمة. وهذا هو الأساس الذي نرتكز عليه دومًا في تقديم حلولنا لتلبية توقعات شركائنا في إحداث الأثر.",
    },
  ],
  vision: {
    title: "الرؤية",
    body: "الريادة في تقديم الاستشارات وحلول تمكين القدرات.",
  },
  mission: {
    title: "الرسالة",
    body: "«سياق» الوجهة المفضلة للمنظمات في تحقيق أعلى تموضع ممكن في تحقيق التغيير المجتمعي المنشود.",
  },
  values: [
    { title: "الأثر", text: "نوجّه أعمالنا نحو نتائج ملموسة ومستدامة تصنع فرقًا حقيقيًا" },
    { title: "الابتكار", text: "نبتكر حلولًا نوعية تنطلق من فهم السياق وتتجاوز القوالب الجاهزة" },
    { title: "التكامل", text: "نوحّد الخبرات والموارد والجهود لنصنع قيمة أكبر مع شركائنا" },
    { title: "النمو", text: "نبني قدرات مستمرة تمكّن الأفراد والمنظمات من التطور والتقدم" },
    { title: "المسؤولية", text: "نتحمّل مسؤولية قراراتنا وجودة مخرجاتنا والأثر الذي نشارك في صناعته" },
    { title: "الاستدامة", text: "نصمّم تدخلات قابلة للاستمرار وتوليد القيمة بعد انتهاء دورنا" },
  ],
  pillars: [
    { title: "تموضع مؤثر", text: "نمكن المنظمات في كافة القطاعات من تحديد نطاق تأثيرها وجوهر هويتها وسبب وجودها، عبر توجيه بوصلتها الاستراتيجية نحو القضايا والاحتياجات والفرص الأكثر إلحاحًا وأولوية." },
    { title: "حلول مبتكرة", text: "نحلل جذور تحديات شركائنا بدقة، ونعتمد على منهجيات وأدوات متخصصة لتوليد خدمات ومنتجات وأنظمة مبتكرة تتجاوز التحديات بكفاءة عالية." },
    { title: "شراكات معززة", text: "نبني شراكات تقوم على التكامل وتوحيد الجهود لتحقيق غايات نوعية وأثر مستدام وتعظيم القيمة المضافة لجميع الأطراف." },
  ],
};

// ---------------------------------------------------------------------------
// Impact story — "برنامج تكوين" (numbers approved by content owner)
// ---------------------------------------------------------------------------
export const IMPACT_STORY = {
  name: "برنامج تكوين",
  contentStatus: "approved",
  lastReviewedAt: "2026-01-01",
  sequence: [
    { label: "السياق", text: "جمعيات وأوقاف تمتلك موارد وإرادة، لكنها بحاجة إلى بناء قدرات مؤسسية تحوّل نيّتها إلى أثر منظّم." },
    { label: "التحدي", text: "غياب الأدوات والمنهجيات التي تمكّن المنظمات من قيادة التغيير داخلها." },
    { label: "تدخّل سياق", text: "تدخل نوعي مكثف يمتد على مدى عشرة أشهر، يجمع بين التأهيل والمرافقة العملية للعاملين في المنظمات." },
    { label: "المخرجات", text: "قيادات مؤهلة، وأدوات قابلة للتطبيق، ومنظمات أكثر جاهزية لقيادة مبادرات استثمار اجتماعي مستدامة." },
  ],
  stats: [
    { value: 10, suffix: "", label: "أشهر من التكوين" },
    { value: 25, prefix: "+", suffix: "", label: "جهة مشاركة" },
    { value: 71, suffix: "", label: "مشاركًا ومشاركة" },
  ],
};

// ---------------------------------------------------------------------------
// Published projects (impact). "عِماد" project intentionally withheld until
// content owner confirms it is not the upcoming product "عماد".
// ---------------------------------------------------------------------------
export const PROJECTS = [
  {
    slug: "social-investment-incubator",
    title: "حاضنة مشاريع الاستثمار الاجتماعي للجمعيات",
    excerpt: "برنامج احتضان يمكّن الجمعيات من تحويل أفكارها إلى مشاريع استثمار اجتماعي مستدامة.",
    body:
      "عملنا مع مجموعة من الجمعيات على تأسيس مسار احتضان متكامل، بدأ من قراءة السياق المؤسسي لكل جمعية، مرورًا بتأهيل الفرق وبناء نماذج العمل، وصولًا إلى بلورة مشاريع استثمار اجتماعي قابلة للتنفيذ والاستدامة.",
    pathSlug: "social-investment",
    contentStatus: "approved",
    sourceUrl: "https://siaq-sa.com/our-services/",
    lastReviewedAt: "2026-01-01",
  },
  {
    slug: "social-innovation-lab",
    title: "تأسيس معمل الابتكار الاجتماعي",
    excerpt: "تصميم وتأسيس معمل يحوّل التحديات المجتمعية إلى نماذج حلول قابلة للتجربة.",
    body:
      "صمّمنا معمل ابتكار اجتماعي بمنهجية واضحة تنقل الأفكار من التصور إلى نموذج أوليّ قابل للاختبار، مع بناء قدرات الفريق الداخلي على إدارة دورات الابتكار بشكل مستقلّ.",
    pathSlug: "social-innovation",
    contentStatus: "approved",
    sourceUrl: "https://siaq-sa.com/our-services/",
    lastReviewedAt: "2026-01-01",
  },
  {
    slug: "social-impact-measurement",
    title: "قياس الأثر الاجتماعي",
    excerpt: "بناء إطار عملي لقياس الأثر الاجتماعي يترجم النشاط إلى نتائج قابلة للإثبات.",
    body:
      "طوّرنا إطارًا لقياس الأثر يربط المدخلات بالمخرجات ثم بالنتائج والأثر، بأدوات عملية تمكّن المنظمة من تتبّع تقدّمها واتخاذ قرارات مبنية على الدليل.",
    pathSlug: "community-development",
    contentStatus: "approved",
    sourceUrl: "https://siaq-sa.com/our-services/",
    lastReviewedAt: "2026-01-01",
  },
];

// ---------------------------------------------------------------------------
// Knowledge hub — one primary + secondary records. Real published items only.
// ---------------------------------------------------------------------------
export const KNOWLEDGE = [
  {
    slug: "knowledge-economy-gateway",
    type: "إصدار",
    featured: true,
    title: "مراكز الابتكار وريادة الأعمال: النماذج العالمية والدروس المستفادة",
    excerpt:
      "إصدار معرفي يستعرض ملامح التحول نحو الاقتصاد المعرفي ودور المنظمات في صناعته.",
    date: "2026-01-01",
    hasDownload: true,
    body:
      "يقدّم هذا الإصدار قراءة في مفهوم الاقتصاد المعرفي ومقوّماته، ويناقش الدور الذي تستطيع المنظمات المجتمعية أن تؤديه في التحول نحوه، مع إطار عملي يربط المعرفة بالأثر.",
    contentStatus: "approved",
    sourceUrl: "https://siaq-sa.com/",
    lastReviewedAt: "2026-01-01",
  },
  {
    slug: "professional-volunteering-vision-2030",
    type: "مقالة",
    featured: false,
    title: "مساهمة التطوع الاحترافي في تحقيق مستهدفات رؤية المملكة 2030",
    excerpt: "يتناول مفهوم التطوع الاحترافي وأهميته في دعم القطاع غير الربحي عبر تسخير الخبرات التخصصية وبناء القدرات المؤسسية.",
    date: "2026-02-15",
    hasDownload: true,
    body: "يتناول المقال مفهوم التطوع الاحترافي وأهميته في دعم القطاع غير الربحي، من خلال تسخير الخبرات التخصصية وبناء القدرات المؤسسية، بما يسهم في رفع الكفاءة التشغيلية وتعظيم الأثر الاجتماعي، ويتناغم مع مستهدفات رؤية المملكة 2030. كما يستعرض أبرز مجالات التطوع الاحترافي وأثره في الحوكمة ونقل المعرفة وتحسين جودة الخدمات ودوره في تمكين المنظمات من تحقيق الاستدامة والنمو.",
    contentStatus: "approved",
    sourceUrl: "https://siaq-sa.com/مساهمة-التطوع-الاحترافي-في-تحقيق-مسته/",
    lastReviewedAt: "2026-08-21",
  },
];

// ---------------------------------------------------------------------------
// Upcoming products — show ONLY these two, marked "قريبًا", no fabrication.
// ---------------------------------------------------------------------------
export const PRODUCTS = [
  { name: "عماد", href: "https://emad.siaq-sa.com/", cta: "استكشف المنتج" },
];

// ---------------------------------------------------------------------------
// Partners & clients — approved logos extracted from the official company
// profile «بروفايل سياق» (شركاؤنا وعملاؤنا). Slugs are stable p00-p52 so that
// individual logo file names never break when the display list is edited.
// (p02 and p20 were removed by owner — corresponding logo files remain
// available but are no longer displayed.)
// ---------------------------------------------------------------------------
export const PARTNERS = [
  { slug: "p00", src: "/assets/partners/logo-00.png", name: "التطوع الصحي" },
  { slug: "p01", src: "/assets/partners/logo-01.png", name: "صندوق دعم الجمعيات" },
  // p02 removed
  { slug: "p03", src: "/assets/partners/logo-03.png", name: "مؤسسة سالم بن محفوظ الأهلية" },
  { slug: "p04", src: "/assets/partners/logo-04.png", name: "الجمعية الخيرية للتنمية بالقرى" },
  { slug: "p05", src: "/assets/partners/logo-05.png", name: "جمعية التوحد والاضطرابات النمائية" },
  { slug: "p06", src: "/assets/partners/logo-06.png", name: "جمعية الأيدي الحرفية الخيرية" },
  { slug: "p07", src: "/assets/partners/logo-07.png", name: "مؤسسة العطاء المكي للعمل التطوعي" },
  { slug: "p09", src: "/assets/partners/logo-09.png", name: "جمعية الدعوة والإرشاد" },
  { slug: "p10", src: "/assets/partners/logo-10.png", name: "جمعية البيضاء" },
  // p11 removed (duplicate)
  { slug: "p12", src: "/assets/partners/logo-12.png", name: "مجلس الجمعيات الأهلية بمنطقة مكة المكرمة" },
  // p13 removed (duplicate)
  { slug: "p14", src: "/assets/partners/logo-14.png", name: "جمعية الأسر المنتجة بمنطقة جازان" },
  { slug: "p15", src: "/assets/partners/logo-15.png", name: "الهيئة العامة للأوقاف" },
  { slug: "p16", src: "/assets/partners/logo-16.png", name: "وزارة الموارد البشرية والتنمية الاجتماعية" },
  { slug: "p17", src: "/assets/partners/logo-17.png", name: "وزارة البيئة والمياه والزراعة" },
  { slug: "p18", src: "/assets/partners/logo-18.png", name: "وزارة الرياضة" },
  { slug: "p19", src: "/assets/partners/logo-19.png", name: "ماجد للتنمية المجتمعية" },
  // p20 removed
  { slug: "p21", src: "/assets/partners/logo-21.png", name: "جامعة الملك فهد للبترول والمعادن" },
  { slug: "p22", src: "/assets/partners/logo-22.png", name: "جمعية الطاقة المستدامة" },
  { slug: "p23", src: "/assets/partners/logo-23.png", name: "جمعية الإعلام السياحي" },
  { slug: "p24", src: "/assets/partners/logo-24.png", name: "جمعية ريادة" },
  { slug: "p25", src: "/assets/partners/logo-25.png", name: "شركة الفوزان القابضة" },
  { slug: "p26", src: "/assets/partners/logo-26.png", name: "شريك سياق" },
  { slug: "p27", src: "/assets/partners/logo-27.png", name: "نماء الشرائع" },
  { slug: "p28", src: "/assets/partners/logo-28.png", name: "وقف العطاء المكي" },
  { slug: "p29", src: "/assets/partners/logo-29.png", name: "جمعية اليقظة النسائية الخيرية" },
  { slug: "p30", src: "/assets/partners/logo-30.png", name: "جمعية أثر الشبابية" },
  { slug: "p31", src: "/assets/partners/logo-31.png", name: "جمعية نفع" },
  { slug: "p32", src: "/assets/partners/logo-32.png", name: "مؤسسة سليمان الراجحي الخيرية" },
  { slug: "p33", src: "/assets/partners/logo-33.png", name: "جمعية أثر" },
  { slug: "p34", src: "/assets/partners/logo-34.png", name: "جمعية أصدقاء مرضى السكري" },
  { slug: "p35", src: "/assets/partners/logo-35.png", name: "جمعية الاستثمار" },
  { slug: "p36", src: "/assets/partners/logo-36.png", name: "جمعية بدار لتنمية الشباب" },
  { slug: "p37", src: "/assets/partners/logo-37.png", name: "جمعية تحفيظ القران بوادي ليه" },
  { slug: "p38", src: "/assets/partners/logo-38.png", name: "لجنة التنمية الأهلية" },
  { slug: "p39", src: "/assets/partners/logo-39.png", name: "جمعية القيم للتنمية" },
  { slug: "p40", src: "/assets/partners/logo-40.png", name: "مواردكم" },
  { slug: "p41", src: "/assets/partners/logo-41.png", name: "وقف البلد الحرام" },
  { slug: "p42", src: "/assets/partners/logo-42.png", name: "مخيم الحج الابتكاري" },
  { slug: "p43", src: "/assets/partners/logo-43.png", name: "جمعية اتحاد المرشدين السياحيين" },
  { slug: "p44", src: "/assets/partners/logo-44.png", name: "جمعية الدعوة بالمعابدة بمكة" },
  { slug: "p45", src: "/assets/partners/logo-45.png", name: "الجمعية النسائية الخيرية الأولى" },
  { slug: "p46", src: "/assets/partners/logo-46.png", name: "الخدمات الإدارية المتخصصة" },
  { slug: "p47", src: "/assets/partners/logo-47.png", name: "جمعية التنمية الأسرية" },
  { slug: "p48", src: "/assets/partners/logo-48.png", name: "جمعية التنمية الأهلية بالمزيزيبة بمكة" },
  { slug: "p49", src: "/assets/partners/logo-49.png", name: "جمعية جسور الشبابية" },
  { slug: "p50", src: "/assets/partners/logo-50.png", name: "المتقدمة" },
  // p51 removed (duplicate)
  { slug: "p52", src: "/assets/partners/logo-52.png", name: "رنين" },
];

// Diagnostic form service options (7 paths + "not sure")
export const SERVICE_OPTIONS = [
  ...PATHS.map((p) => ({ value: p.slug, label: p.title })),
  { value: "other", label: "أخرى" },
];

// ---------------------------------------------------------------------------
// 301 Redirect map: legacy WordPress URLs → new destinations.
// ---------------------------------------------------------------------------
export const REDIRECTS = {
  "/about-us": "/about",
  "/about-us/": "/about",
  "/our-services": "/services",
  "/our-services/": "/services",
  "/contact-2": "/contact",
  "/contact-2/": "/contact",
  "/blog-2": "/publications",
  "/blog-2/": "/publications",
  "/التدريب": "/",
  "/التدريب/": "/",
  "/التدريب-2": "/",
  "/التدريب-2/": "/",
};
